import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ticket-summary tech-flex" }
const _hoisted_2 = { class: "w-main-fixed task-chat" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Blocks", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Notice 1 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Notice 2 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Notice 3 ", -1)

import { File } from '@/app.context/workspace/tickets/_spec/Ticket.Im.Rmodel'

import TaskBlockAssignComponent from '@/components/Workspaces/tickets/tasks/_spec/TaskBlockAssignComponent.vue'
import TicketDescription from '@/components/Workspaces/tickets/_spec/TicketDescription.vue'
import TicketIm from '@/components/Workspaces/tickets/_spec/TicketIm.vue'
import { IFileStorage } from '@/io/storages';
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { block } from '@/ops/workspaces/tickets/todo.processor'
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { useAppContext } from '@/app/_tech';
import { BlockRmodel, blockResolutionString } from '@/app.context/workspace/tickets/tasks/block.rmodel';

import { personSorter } from '@/app.context/workspace/persons.set/persons.alg'
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import chatController, { setupEscapeHook } from '@/controllers/workspaces/tickets/_spec/ticket.controller.chat'

import TicketFiles from '@/components/Workspaces/tickets/_spec/TicketFiles.vue'

import sys from '@/sys';



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSummary',
  props: {
    model: {},
    files: {},
    level: {},
    escape: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const upload = ref<HTMLInputElement | null>(null)

const props = __props



async function onFileChanged($event: Event): Promise<void> {

    const target = $event.target as HTMLInputElement;
    if (target && target.files) {
        //file.value = target.files[0];



        //target.files

        // const files = [...target.files]; //.map(file => { console.log(file) })


        // const s = props.files

        // const t = props.model.ticket

        // const m = props.model.storage

        // if (s != null && t != null && m != null) {

        //     files.forEach(x => {

        //         s.push(t.workspace.wid, t.n, x.name, x, x.type)
        //             .then(url => {

        //                 console.log(url)

        //                 const f = new File(x.name, url)



        //                 //hack to avoid VUE error 'attemtp to change property'
        //                 const files_buffer = props.model.pack?.files

        //                 if (files_buffer) files_buffer.push(f)

        //                 m.file(t.workspace.wid, t.n, x.name, url)
        //             })
        //     })
        // }
        // else sys.warn("/workspaces/ticket - Can't process file - file storage is null")


        upload.value!.value = ''

        //console.log(file.value)
    }

    return Promise.resolve()


}





//const state = stateObject(props.model)

const state: { blocking: boolean, workableOption: boolean } = reactive({ blocking: false, workableOption: props.model.todo != props.model.todo?.person.current })


const emit = __emit


const im = ref<InstanceType<typeof TicketIm> | null>(null)

const desc = ref<InstanceType<typeof TicketDescription> | null>(null)




onMounted(observeHeight)

setupEscapeHook(() => emit('close'))

function onScreenResize(event: any) {

    //const e = document.getElementById('ui-ticket-fixup-main-description')

    const e = desc.value?.$el as HTMLElement

    //desc.value?.$el

    if (e != null) {
        const r = e.getBoundingClientRect()

        chat.height = window.innerHeight - r.bottom
    }
    else sys.warn("Can't find 'ui-ticket-fixup-main-description'")


}

onMounted(() => {

    window.addEventListener('resize', onScreenResize, true);
})

onBeforeUnmount(() => {

    window.removeEventListener('resize', onScreenResize, true);
})


onMounted(() => onScreenResize(null))

function observeHeight() {

    const e = desc.value?.$el

    if (e != null) {

        const resizeObserver = new ResizeObserver(function (args: ResizeObserverEntry[]) {

            if (args.length == 1) {

                const e = args[0].target as HTMLElement

                chat.height = window.innerHeight - e.getBoundingClientRect().bottom
            }
            else sys.warn('multip resize observer items')

        });

        resizeObserver.observe(e);
    }
    else sys.warn("Can't find 'ui-ticket-fixup-main-description'")
}



const taskBlockAssigningComponent = ref<InstanceType<typeof TaskBlockAssignComponent> | null>(null)


const context = useAppContext()




//'workable option' - idea is that if we open side block menu when ticket is running - you can assingl block, but ticket remain 'workable'
//oppostite when you assigne block throug 'stand' - it mandatory should delay todo  


const chat: { height: number } = reactive({ height: 0 })

const blocks = computed(() => {

    const buffer = props.model.todo?.task.blocks ?? []

    return buffer.sort(blockSorter)

    function blockSorter(a: BlockRmodel, b: BlockRmodel) {

        if (a.person == null) return -1;
        if (b.person == null) return +1;

        return personSorter(a.person, b.person, context.cursor.workspace?.user_person ?? null)
    }
})

function onBlockClick(todo: TodoRmodel) {

    const x = taskBlockAssigningComponent?.value

    const data = x?.data() ?? { impersonal: false, persons: [], workable: false };

    block(context, todo, data)

    //x

    state.blocking = false
}


const isTask = computed(() => { return props.model.todo != null && props.model.todo.isTask() });

const isWorkableTask = computed(() => { return isTask.value && props.model.todo!.task.isWorkable });

const c = chatController(im, props)






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TicketDescription, {
        ref_key: "desc",
        ref: desc,
        id: "ui-ticket-fixup-main-description",
        model: props.model
      }, null, 8, ["model"]),
      _createVNode(TicketIm, {
        ref_key: "im",
        ref: im,
        class: "chat",
        messages: _ctx.model.messages,
        onMessage: _unref(c).message,
        onFiles: _unref(c).files,
        height: chat.height
      }, null, 8, ["messages", "onMessage", "onFiles", "height"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(TicketFiles, {
        model: _ctx.model.pack,
        ticket: _ctx.model.ticket,
        storage: _ctx.model.ticket!.workspace.storage,
        files: props.files
      }, null, 8, ["model", "ticket", "storage", "files"]),
      (isTask.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!state.blocking)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _withDirectives(_createElementVNode("div", null, _hoisted_4, 512), [
                    [_vShow, blocks.value?.length ?? false]
                  ]),
                  _withDirectives(_createElementVNode("div", null, "[Workable]", 512), [
                    [_vShow, isWorkableTask.value]
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blocks.value, (b, j) => {
                      return (_openBlock(), _createElementBlock("span", { key: j }, [
                        (b.person != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" @" + _toDisplayString(b.person) + " " + _toDisplayString(b.resolution != null ? `[${_unref(blockResolutionString)(b.resolution)}]` : ''), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" [general] " + _toDisplayString(b.resolution != null ? `[${_unref(blockResolutionString)(b.resolution)}]` : ''), 1)
                            ], 64))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (state.blocking = true))
                  }, "Block")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(TaskBlockAssignComponent, {
                    ref_key: "taskBlockAssigningComponent",
                    ref: taskBlockAssigningComponent,
                    task: _ctx.model.todo!.task,
                    persons: _ctx.model.ticket!.workspace.persons(),
                    workableOptionEnabled: state.workableOption,
                    workableInitialValue: !state.workableOption
                  }, null, 8, ["task", "persons", "workableOptionEnabled", "workableInitialValue"]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onBlockClick(_ctx.model.todo!)))
                  }, "Ok"),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (state.blocking = false))
                  }, "Cancel")
                ], 64))
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ])
  ]))
}
}

})